/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

export enum DepreciationMethodId {
  CA_Tax_NoDepreciation = 28,
  CA_Tax_Immediate = 29,
  CA_Tax_DoesntExist = 30,
  CA_Accounts_StraightLine = 31,
  CA_Accounts_DecliningBalance = 32,
  CA_Accounts_NoDepreciation = 33,
  CA_Accounts_Immediate = 34,
  CA_Accounts_DoesntExist = 35,
  CA_Accounts_UnitsOfProduction = 102,
  CA_Tax_NotCapitalised = 128,
  CA_Accounts_NotCapitalised = 129,
  CA_Tax_Class10_1 = 154,
  CA_Tax_Class13 = 158,
  CA_Tax_Class29 = 159,
  CA_Accounts_DecliningBalance200 = 163,
  CA_Accounts_DecliningBalance150 = 164,
  US_Tax_GDS200_HY = 1000,
  US_Tax_GDS200_MQ = 1001,
  US_Tax_GDS150_HY = 1002,
  US_Tax_GDS150_MQ = 1003,
  US_Tax_GDS_SL_HY = 1004,
  US_Tax_GDS_SL_MQ = 1005,
  US_Tax_GDS_SL_MM = 1006,
  US_Tax_ADS150_HY = 1007,
  US_Tax_ADS150_MQ = 1008,
  US_Tax_ADS_SL_HY = 1009,
  US_Tax_ADS_SL_MQ = 1010,
  US_Tax_ADS_SL_MM = 1011,
  US_Tax_Immediate = 1020,
  US_Tax_NoDepreciation = 1021,
  US_Tax_DoesntExist = 1023,
  US_Tax_Section179 = 1024,
  US_Accounts_DecliningBalance200 = 1050,
  US_Accounts_DecliningBalance150 = 1051,
  US_Accounts_StraightLine = 1052,
  US_Accounts_Immediate = 1060,
  US_Accounts_NoDepreciation = 1061,
  US_Accounts_DoesntExist = 1062,
  US_Accounts_UnitsOfUse = 1063,
  US_Tax_NotCapitalised = 1064,
  US_Accounts_NotCapitalised = 1065,
  US_Tax_Section197 = 1067,
  US_Tax_Section167f = 1068,
  Generic_Tax_StraightLine = 2000,
  Generic_Tax_DiminishingValue = 2001,
  Generic_Tax_DiminishingValue150 = 2002,
  Generic_Tax_DiminishingValue200 = 2003,
  Generic_Tax_Immediate = 2004,
  Generic_Tax_NoDepreciation = 2005,
  Generic_Tax_DoesntExist = 2006,
  Generic_Tax_UnitsOfUse = 2007,
  Generic_Accounts_StraightLine = 2010,
  Generic_Accounts_DiminishingValue = 2011,
  Generic_Accounts_DiminishingValue150 = 2012,
  Generic_Accounts_DiminishingValue200 = 2013,
  Generic_Accounts_Immediate = 2014,
  Generic_Accounts_NoDepreciation = 2015,
  Generic_Accounts_DoesntExist = 2016,
  Generic_Accounts_UnitsOfUse = 2017,
  Generic_Tax_NotCapitalised = 2018,
  Generic_Accounts_NotCapitalised = 2019,
  Generic_Tax_DiminishingValue100 = 2020,
  Generic_Accounts_DiminishingValue100 = 2021,
}
